import ICON__brush_clean from '@/assets/icons/lucide/brush-clean.svg?react';
import { buttonVariants, UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { VariantProps } from 'class-variance-authority';

interface PROPS {
  field: FIELD__image_asset;
  text?: string;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  size?: VariantProps<typeof buttonVariants>['size'];
}

export function G_GRAPH__BUTTON__image_clear({ field, text = '', variant = 'no-border-on-bar', size = 'square-6' }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */
  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();

    field_new.image__clear();

    let graph_new = graph.clone();
    graph_new.field__replace(field_new);

    let field_mask = graph_new.field_image__get_mask_for(field_new);
    if (!field_mask.is_stub()) {
      let field_mask_new = field_mask.clone();
      field_mask_new.image__clear();
      graph_new.field__replace(field_mask_new);
    }

    await UTILS__graph_data.update(graph_new);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  if (!field.is_ready_for_manual_edit()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (!field.get_has_content()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to clear
  if (!field.image__is_initialized) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} {...{ onClick, variant, size }} title="Clear image">
      <ICON__brush_clean className="!size-3" />
      {text}
    </UI_PRIMITIVE__button>
  );
}
